import {useParams} from 'react-router-dom';

import {PoolsTable} from '@widgets/pool/PoolsTable';

export const PoolsTab = () => {
  const {id} = useParams<{id: string}>();
  return <PoolsTable kind="user" id={id ?? ''} />;
};
